import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M960 287.8H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h896c35.3 0 64 28.7 64 64s-28.7 64-64 64zM960 576H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h896c35.3 0 64 28.7 64 64s-28.7 64-64 64zM960 864.3H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h896c35.3 0 64 28.7 64 64s-28.7 64-64 64z"
        id="形状"
      />
    </svg>
  )
}
const CollapseIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
CollapseIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
CollapseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default CollapseIcon
